var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNulllink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9ca2b5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nulllink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,12a6,6,0,0,1-6-6,5.75,5.75,0,0,1,1.75-4.25A5.75,5.75,0,0,1,16,0a5.75,5.75,0,0,1,4.25,1.75A5.75,5.75,0,0,1,22,6,6,6,0,0,1,16,12Zm0-2a4,4,0,1,0-4-4,3.8,3.8,0,0,0,1.18,2.82A3.8,3.8,0,0,0,16,10Z",
    transform: "translate(-0.01 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,10A3.8,3.8,0,0,1,1.18,8.82a4,4,0,0,1,0-5.65A3.84,3.84,0,0,1,4,2,3.91,3.91,0,0,1,6.83,3.17a4,4,0,0,1,0,5.65A3.82,3.82,0,0,1,4,10Z",
    transform: "translate(-0.01 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNulllink);
export default __webpack_public_path__ + "static/media/nulllink.867b421ef8ee0f5aca7299dd9507cc3b.svg";
export { ForwardRef as ReactComponent };